module.exports = __webpack_public_path__ + "img/logonewblack.f930c774.svg";